import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    ImgCapaBackground,
} from '../../../business-components/Img/Img'

import {
    nomeCurtoCliente,
    nomeCurtoConjuge,
} from '../../../business-rules/String/nomeCurto'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'



const EstudoReportCapaPadrao = ({ variaveisGlobais, values, vars }) => {

    return (
        <ImgCapaBackground
            variaveisGlobais={variaveisGlobais}
            values={values}
            vars={vars}
            nomeCurtoCliente={
                pesquisaList(values.exclusaoFamiliares, HARDCODE.idFamiliarCliente).id
                    ?
                        ''
                    :
                        nomeCurtoCliente(values)}
            nomeCurtoConjuge={
                pesquisaList(values.exclusaoFamiliares, HARDCODE.idFamiliarConjuge).id
                    ?
                        ''
                    :
                        nomeCurtoConjuge(values)
            }
        />
    )
}

export default EstudoReportCapaPadrao